<template>
    <pleitos-detalhar
        :dataServicos="obterDataServicos()"
        rotaListagem="Pleitos_Financeiro"
    ></pleitos-detalhar>
</template>

<script>
import PleitosDetalhar from '../componentes/PleitosDetalhar'
import PleitosServicos from './PleitosServicos'

export default {
    components: {
        PleitosDetalhar
    },

    methods: {
        obterDataServicos() {
            return PleitosServicos
        }
    }
}
</script>